import { Reducer, Action } from "redux";
import { IPresetProfileState, KnownAction, REPIQ_PRESET_PROFILE, SHOW_LOADER } from "./types";

export const reducer: Reducer<IPresetProfileState> = (state: IPresetProfileState | undefined, incomingAction: Action): IPresetProfileState => {
    if (state === undefined) {
        return { presetProfileData: [], isLoading: false };
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case REPIQ_PRESET_PROFILE:
            return {
                ...state,
                presetProfileData: action.repIQPresetProfileData,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
